import React from "react";
import PropTypes from "prop-types";

function DashboardIconCard({ type, icon, preline, headline }) {
  if (type === "primary") {
    return (
      <div className="card card-primary card-dashboard-icon">
        <div className="card-body">
          {icon && (
            <div className="card-image">
              <img src={icon} alt="" />
            </div>
          )}

          <div className="card-content">
            <div className="card-preline" dangerouslySetInnerHTML={{ __html: preline }} />
            <h5
              className="card-headline text-primary"
              dangerouslySetInnerHTML={{ __html: headline }}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="card card-tertiary card-dashboard-icon">
      <div className="card-body">
        {icon && (
          <div className="card-image">
            <img src={icon} alt="" />
          </div>
        )}

        <div className="card-content">
          <div className="card-preline" dangerouslySetInnerHTML={{ __html: preline }} />
          <h5
            className="card-headline text-primary"
            dangerouslySetInnerHTML={{ __html: headline }}
          />
        </div>
      </div>
    </div>
  );
}

DashboardIconCard.propTypes = {
  type: PropTypes.string,
  preline: PropTypes.string,
  headline: PropTypes.string,
  icon: PropTypes.string,
};

export default DashboardIconCard;
